import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "minus",
  "use": "minus-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" fill=\"none\" id=\"minus\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6 17.571A2.571 2.571 0 0 1 8.571 15H27.43a2.57 2.57 0 1 1 0 5.143H8.57A2.572 2.572 0 0 1 6 17.57Z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol